import { render, staticRenderFns } from "./filialeForm.vue?vue&type=template&id=4e288444&scoped=true&"
import script from "./filialeForm.vue?vue&type=script&lang=js&"
export * from "./filialeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e288444",
  null
  
)

export default component.exports